import { PrintDocument, RenderOutput } from '../document'
import { resolveParams } from '../params'
import { ProtocolKind } from '../types'
import { renderEscPos } from './escpos'
import { HtmlOptions, renderHtml } from './html'
import { renderEpl, renderTspl, renderZpl } from './labels'
import { renderStar } from './star'

export { escPosDrawerKick } from './escpos'
export type { HtmlOptions } from './html'

/** One entry per protocol the code speaks; a catalog model picks one by name and supplies its params. */
export const render = (
  protocol: ProtocolKind,
  doc: PrintDocument,
  params?: Record<string, unknown>,
  options: HtmlOptions = {}
): RenderOutput => {
  const p = resolveParams(protocol, params)
  switch (protocol) {
    case 'html':
      return renderHtml(doc, p, options)
    case 'escpos':
      return renderEscPos(doc, p)
    case 'star':
      return renderStar(doc, p)
    case 'tspl':
      return renderTspl(doc, p)
    case 'zpl':
      return renderZpl(doc, p)
    case 'epl':
      return renderEpl(doc, p)
    default:
      throw new Error(`Protocol ${protocol} does not print`)
  }
}
